export default {
  header: "Rock, Paper or Scissors",
  view: "rockPaperScissors"
};